import { render, staticRenderFns } from "./DoctorListPage.vue?vue&type=template&id=6b3094ac&scoped=true"
import script from "./DoctorListPage.vue?vue&type=script&lang=js"
export * from "./DoctorListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3094ac",
  null
  
)

export default component.exports